import { TosItem } from '@bepatient/common';
import { CoreActions, CoreActionsTypes } from '@bepatient/core';
import { TOSDetailsType } from '@bepatient/onboarding-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MyAccountActions, MyAccountActionsTypes } from './my-account.actions';
import {
  MyAccountForm,
  MyAccountFormTypes,
  PageDetail
} from './my-account.models';

interface MyAccountState {
  forms: Array<MyAccountForm>;
  tosItems: Array<TosItem>;
  selectedTosDetails: Array<TOSDetailsType>;
  selectedTosIndex: number;
  changePasswordFailed: boolean;
  documentDetails: any; // Todo create interface for documentDetails
  userLanguageChanged: string;
  helpContent: any;
  selectedSettingType: any;
  previousSettingType: PageDetail;
}

export const myAccountInitialState: MyAccountState = {
  forms: [],
  tosItems: [],
  selectedTosDetails: undefined,
  selectedTosIndex: undefined,
  changePasswordFailed: false,
  documentDetails: undefined,
  userLanguageChanged: undefined,
  helpContent: undefined,
  selectedSettingType: undefined,
  previousSettingType: undefined
};

export function myAccountReducer(
  state = myAccountInitialState,
  action: CoreActions | MyAccountActions
): MyAccountState {
  switch (action.type) {
    case CoreActionsTypes.LOGOUT:
      return myAccountInitialState;

    case MyAccountActionsTypes.LOAD_FORMS_SUCCESS:
      // Only return the valid MyAccountFormTypes
      let validForms: MyAccountForm[] = [];
      if (action.payload.length > 0) {
        action.payload.map(form => {
          Object.values(MyAccountFormTypes).find(type => type == form.type)
            ? validForms.push(form)
            : void 0;
        });
      }
      return { ...state, forms: validForms };

    case MyAccountActionsTypes.LOAD_TOS_ITEMS_SUCCESS:
      return { ...state, tosItems: action.payload };

    case MyAccountActionsTypes.LOAD_TOS_ITEMS_V2_SUCCESS:
      return { ...state, tosItems: action.payload };

    case MyAccountActionsTypes.LOAD_TOS_ITEM_DETAILS_SUCCESS:
      return { ...state, selectedTosDetails: action.payload };

    case MyAccountActionsTypes.SET_SELECTED_TOS_INDEX:
      return { ...state, selectedTosIndex: action.payload };

    case MyAccountActionsTypes.SET_NEW_PASSWORD:
      return { ...state, changePasswordFailed: false };

    case MyAccountActionsTypes.SET_NEW_PASSWORD_FAILED:
      return { ...state, changePasswordFailed: true };

    case MyAccountActionsTypes.LOAD_DOCUMENT_SUCCESS:
      return { ...state, documentDetails: action.payload };

    case MyAccountActionsTypes.USER_LANGUAGE_CHANGED:
      return { ...state, userLanguageChanged: action.payload };

    case MyAccountActionsTypes.SET_USER_PREFERENCE_SUCCESS:
      return { ...state, userLanguageChanged: void 0 };

    case MyAccountActionsTypes.LOAD_HELP_SUCCESS:
      return { ...state, helpContent: action.payload };

    case MyAccountActionsTypes.SET_SELECTED_SETTING_TYPE:
      return { ...state, selectedSettingType: action.payload };

    case MyAccountActionsTypes.SET_PREVIOUS_SETTING_TYPE:
      return { ...state, previousSettingType: action.payload };

    default:
      return state;
  }
}

const myAccountState = createFeatureSelector<MyAccountState>('myAccount');

export const selectorMyAccountForms = createSelector(
  myAccountState,
  state => state.forms
);

export const selectorMyAccountTosItems = createSelector(
  myAccountState,
  state => state.tosItems
);

export const selectorMyAccountSelectedTosDetails = createSelector(
  myAccountState,
  state => state.selectedTosDetails
);

export const selectorMyAccountSelectedTosIndex = createSelector(
  myAccountState,
  state => state.selectedTosIndex
);

export const selectorChangePasswordFailed = createSelector(
  myAccountState,
  state => state.changePasswordFailed
);

export const selectorMyAccountDocumentDetails = createSelector(
  myAccountState,
  state => state.documentDetails
);

export const selectorMyAccountUserLanguageChanged = createSelector(
  myAccountState,
  state => state.userLanguageChanged
);

export const selectorMyAccountHelpContent = createSelector(
  myAccountState,
  state => state.helpContent
);

export const selectorMyAccountSelectedSettingType = createSelector(
  myAccountState,
  state => state.selectedSettingType
);

export const selectorMyAccountPreviousSettingType = createSelector(
  myAccountState,
  state => state.previousSettingType
);
